<template>
  <TheDemandHeader
    :title="title"
    :isCenter="true"
    page="4"
    :clickBackButtonEvent="ncDemandClose"
  />

  <!-- 発着駅と時間と人数を表示 -->
  <TheDemandComfirmation :Reservation="tentativeReservation" :selectedService="selectedService"/>

  <TheDemandActionButton4 
      :selectedService="selectedService" 
      :tentativeReservation="tentativeReservation"
      :countDown="countDown"
  />

</template>

<script>
import { mapGetters } from "vuex";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import nativeHandlerService from "@/services/nativeHandler";
import API from "@/API";

export default {
  name: "TemplateDemandBooking4",
  setup(props) {
    const router = useRouter();
    const store = useStore();

    const countDown = ref(50)
    const title = ref(null)

    const selectedService = store.getters["demand/selectedService"];
    const tentativeReservation = store.getters["demand/tentativeReservation"];

    onMounted(async () => {
      //カウントダウンスタート
      setInterval(() => updateCountdown(), 1000);
    })

    const updateCountdown =  async() => {
      if (countDown.value > 0) {
        countDown.value -= 1;
        title.value = `キャンセルまで <font style='color:red; font-size:1.5rem;'>${countDown.value}</font> 秒`;
      } else {
        title.value = `キャンセルされました`;
      }
    }

    const ncDemandClose = async() => {
      if (countDown.value > 0) {
        await API.putDeclineEbusTentativeReservation(tentativeReservation.id)
      }
      await nativeHandlerService.demand.ncDemandClose();
    }

     return{
      selectedService,
      countDown,
      title,
      selectedService,
      tentativeReservation,
      ncDemandClose,
    }
  }
};
</script>
